export default {"src":"/_next/static/media/BILL.af77394b.svg","height":18,"width":18};